export const getBookingDate = (booking, dataMode) => {
  if (dataMode === "Booked Data") {
    return new Date(booking.createdAt).toLocaleDateString();
  } else {
    const fromdateParts = booking.fromdate.split("-");
    const [day, month, year] = fromdateParts.map(Number);
    return new Date(year, month - 1, day).toLocaleDateString();
  }
};
